import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/services/auth.interceptor';
import { CommonService } from './core/services/common.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';


const HttpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const provideTranslation = () => ({
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,withHashLocation()), 
    provideClientHydration(), 
    provideAnimationsAsync(), 
    provideHttpClient(withInterceptors([authInterceptor])),
    // Blocks Angular from constructing ANY component (including HeaderComponent) until the
    // in-memory access/id token is repopulated from the persisted refresh token - see
    // CommonService.initializeSessionFromRefreshToken() for why this can't just live in
    // app.component.ts's ngOnInit (that runs too late, after child components already render).
    provideAppInitializer(() => inject(CommonService).initializeSessionFromRefreshToken()),
    importProvidersFrom([
      HttpClientModule, 
      TranslateModule.forRoot(provideTranslation())
    ]),
    providePrimeNG({
      theme: {
        preset: Lara
      }
    })
  ]
};
